var _style, _path, _path2, _g, _path3, _path4, _path5, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBlik = function SvgBlik(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135.6 64.2",
    style: {
      enableBackground: "new 0 0 135.6 64.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000095330598619493448740000012760375389027044013_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.7,0H7.9C3.5,0,0,3.5,0,7.9v48.4c0,4.4,3.5,7.9,7.9,7.9h119.8c4.4,0,7.9-3.5,7.9-7.9V7.9 C135.6,3.5,132.1,0,127.7,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -855.0665,
    y1: 15.931,
    x2: -855.0665,
    y2: 14.942,
    gradientTransform: "matrix(133.983 0 0 62.525 114632.1719 -933.1696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    style: {
      stopColor: "#484848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#212121"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    style: {
      stopColor: "#080808"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.7,0.8H7.9C4,0.8,0.8,4,0.8,7.9v48.4c0,3.9,3.2,7.1,7.1,7.1l0,0h119.8c3.9,0,7.1-3.2,7.1-7.1l0,0V7.9 C134.8,4,131.6,0.8,127.7,0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.254 6.714)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 24.4,
    cy: 8.2,
    r: 7.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,3.4H45v45h-7.9V3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,18.9h8v29.4h-8V18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,18.6c-2.5,0-4.9,0.6-7.1,1.8v-17H1.5v30.2c0,8.3,6.7,15,15,15s15-6.7,15-15S24.8,18.6,16.5,18.6 L16.5,18.6z M16.5,40.8c-4,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2S20.5,40.8,16.5,40.8L16.5,40.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072260275382547737510000005307957689268922506_",
    gradientUnits: "userSpaceOnUse",
    x1: -967.8513,
    y1: 61.3798,
    x2: -967.1447,
    y2: 62.0874,
    gradientTransform: "matrix(9.203881e-02 -14.1757 14.1757 9.203881e-02 -761.6409 -13712.4707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E52F08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E94F96"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000072260275382547737510000005307957689268922506_)"
    },
    cx: 24.4,
    cy: 8.2,
    r: 7.1
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,3.4H45v45h-7.9V3.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,18.9h8v29.4h-8V18.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,18.6c-2.5,0-4.9,0.6-7.1,1.8v-17H1.5v30.2c0,8.3,6.7,15,15,15s15-6.7,15-15S24.8,18.6,16.5,18.6 L16.5,18.6z M16.5,40.8c-4,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2S20.5,40.8,16.5,40.8L16.5,40.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.003 -.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,55h10.2l-12.3-15.8l11.1-13.6H106L95.2,39.3V10.1h-7.9v45h7.9V39.4L106.3,55z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlik, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };